import React, { useEffect, useMemo, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import DataTableComponent from "../../../../../Util/DataTable/DataTable";
import RateCard from "../../../../../Util/RateCard/RateCard";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./Event.css";
import "../EventsOverviewPage/EventsOverviewPage.css"
import { config } from "../../../../../config";
import { EVENT_STATUS, LEAD_STATUS } from "../../../../../Util/helper";
import axiosApi from "../../../../../core/interceptor/interceptor";
import * as moment from 'moment';
import add from "../../../../../assets/add-icon.svg";
import qrscanicon from "../../../../../assets/qr-scan.svg";
import calendar from '../../../../../assets/calendar-icon.svg';
import CustomSelect from "../../../../../Util/CustomSelect/CustomSelect";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import timeGridPlugin from '@fullcalendar/timegrid';
import Calendar from "../Calendar/Calendar";
import Scanner from '../Scanner/Scanner';
import Popup from "reactjs-popup";
import { toast } from "react-toast";
function Event(props) {
  const EVENTSTATUS = [
    {
      id: 'active',
      title: 'Active'
    },
    {
      id: 'complete',
      title: 'Complete'
    },
    // {
    //   id: 'delete',
    //   title: 'Delete',
    // },
    {
      id: 'cancel',
      title: 'Cancel',
    },
  ];

  const columns = useMemo(() => {
    const coln = [
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}> Name</div>,
        selector: () => 'title',
        className: 'left-align',
        minWidth: '130px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.title ? `${row.title}` : 'N/A'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Start Date</div>,
        selector: () => 'start_date_time',
        minWidth: '100px !important',
        sortable: 'true',
        style: {
          padding: '0',
          whiteSpace: 'pre-wrap !important'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', justifyContent: 'flex-start !important', textAlign: 'left', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.start_date_time ? moment(row.start_date_time).format('MM/DD/YYYY, hh:mm A') : 'N/A'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>End Date</div>,
        selector: () => 'end_date_time',
        minWidth: '100px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.end_date_time ? moment(row.end_date_time).format('MM/DD/YYYY, hh:mm A') : 'N/A'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Type</div>,
        selector: () => 'type',
        minWidth: '90px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.type ? EVENT_STATUS[row.type] : 'N/A'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Occasion</div>,
        selector: () => 'occasion',
        minWidth: '100px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.occasion ? row.occasion : 'N/A'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Client Name</div>,
        selector: () => 'client_name',
        minWidth: '136px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.client_name ? row.client_name : 'N/A'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Client Phone</div>,
        selector: () => 'client_phone',
        minWidth: '120px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.client_phone ? row.client_phone : 'N/A'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Venue</div>,
        selector: () => 'venue',
        minWidth: '136px !important',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row && row?.event_venue && row?.event_venue?.name ? row?.event_venue?.name : 'TBD'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}>Captured Date</div>,
        selector: () => 'captured_date_time',
        minWidth: '98px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>{row.captured_date_time ? moment(row.captured_date_time).format('MM/DD/YYYY') : 'N/A'}</div>)
      },
      {
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}> Status</div>,
        selector: () => 'status',
        minWidth: '120px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}><CustomSelect data={EVENTSTATUS} placeholder={row.status ? LEAD_STATUS[row.status] : 'Active'} shoWarning={true} onSelect={(e) => handleStatusChange(row?.id, e)} menuPortalTarget={document.body} selector='title' /></div>)
      },
    ];
    if (props.type === 'public-events') {
      coln.pop();
      coln.push({
        name: <div className="table-header" style={{ padding: '8px 10px', textAlign: 'left', wordBreak: 'break-word' }}> Action</div>,
        selector: () => 'status',
        minWidth: '120px !important',
        sortable: 'true',
        style: {
          padding: '0'
        },
        cell: row => (<div className="inner-cell" data-tag="allowRowEvents" style={{ width: '100%', padding: '8px 10px', minHeight: '32px', display: 'inline-flex', alignItems: 'center', height: '100%', fontSize: '13px', fontWeight: '500', lineHeight: '18px', color: 'var(--blk)', fontFamily: 'Mulish, sans-serif' }}>
          <button className="btn btn-primary qr" onClick={() => scanFn(row)}>
            <img src={qrscanicon} title="Scan Ticket" />
          </button>
        </div>)
      });
    }
    return coln;
  }, [props.type]);

  const [scan, setScan] = useState({
    open: false,
    event_id: 0,
  });
  const [successPopup, setSuccessPopup] = useState({
    open: false,
    event: {}
  });
  const history = useHistory();
  const [totalPage, setTotalPage] = useState(0);
  const [events, setEvents] = useState([]);
  const [queryparam, setQueryparam] = useState({
    title: '',
    client_name: '',
    start_date_time: '',
    end_date_time: '',
    direction: 'desc',
    sort_column: '',
    page: 1,
    limit: 50,
  });
  const [startDate, setStartDate] = useState('');
  const [calendarView, setCalendarView] = useState(false);
  const [endDate, setEndDate] = useState('');
  const [overview, setOverview] = useState({
    total: 0,
    upcoming: 0,
    completed: 0,
    cancel: 0,
  });

  const handleChange = (e) => {
    // if (e.target.name === 'start_date_time') {
    //   setStartDate(e.target.value);
    // } else if (e.target.name === 'end_date_time') {
    //   setEndDate(e.target.value);
    // }
    let stateFunc = null;
    if (e.type === 'sort') {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.value,
        'direction': e.target.direction,
      })
    } else {
      stateFunc = (prevValue) => ({
        ...prevValue,
        [e.target.name]: e.target.name === 'start_date_time' ? e.target.value : e.target.name === 'end_date_time' ? e.target.value : String(e.target.value).trim(),
      })
    }
    setQueryparam(stateFunc);
  }

  const handleStatusChange = (id, data) => {
    if (data) {
      axiosApi.put(`${config.apiUrl}/events/${id}/${data?.id}`)
        .then((res) => {
          getEvents(queryparam);
          getOverview();
        })
    }
  }

  useEffect(() => {
    handleChange({
      target: {
        name: 'start_date_time',
        value: startDate
      }
    })
  }, [startDate]);

  useEffect(() => {
    handleChange({
      target: {
        name: 'end_date_time',
        value: endDate
      }
    })
  }, [endDate]);

  const getEvents = (params) => {
    params.type = props.type === 'public-events' ? 'public' : '';
    axiosApi.get(`${config.apiUrl}/events`, { params })
      .then((res) => {
        if (res && res.data && res.data.data && res.data.data.rows) {
          res.data.data.rows.forEach(element => {
            element.start = moment(element.start_date_time).format('YYYY-MM-DD HH:mm')
            element.end = moment(element.end_date_time).format('YYYY-MM-DD HH:mm')
          });
          setEvents(res.data.data.rows);

        }
      })
  }

  const getOverview = () => {
    axiosApi.get(`${config.apiUrl}/events/overview`)
      .then((res) => {
        if (res && res.data && res.data.data) {
          const data = res.data.data;
          setOverview({
            total: data[0].total,
            upcoming: data[0].upcoming,
            completed: data[0].completed,
            cancel: data[0].cancel
          });
        }
      })
  }

  useEffect(() => {
    getEvents(queryparam);
    getOverview();
    //eslint-disable-next-line
  }, [])

  useEffect(() => {
    getEvents(queryparam);
    //eslint-disable-next-line
  }, [queryparam.page, queryparam.limit, queryparam.direction, queryparam.sort_column])

  const handleSearch = (e) => {
    e.preventDefault();
    setQueryparam(() => ({
      ...queryparam,
      'page': 1,
      'direction': '',
      'sort_column': '',
    }))
    getEvents(queryparam);
  }

  useEffect(() => {
    props.history.listen((location, action) => {
      if (location.search.indexOf('calendar') !== -1) {
        setCalendarView(true);
      } else {
        setCalendarView(false);
      }
    });

    if (props?.location?.search && props?.location?.search.indexOf('calendar') !== -1) {
      setCalendarView(true);
    }
  }, []);

  const scanFn = (event) => {
    setScan({
      open: true,
      event_id: event.id,
    });
  }

  const verfiyTicket = (result, event_id) => {
    try {
      const data = JSON.parse(result);
      data.event_id = event_id;
      axiosApi.post(`${config.apiUrl}/events/verifiy-ticket`, data)
        .then((res) => {
          setSuccessPopup({
            open: true,
            event: res.data.data.event,
            event_count: (res.data.data.event_tickets.map(x => x.status === 'active').length),
            event_tickets: (res.data.data.event_tickets.filter(x => x.status === 'active')),
            ticketInfo: res.data.data,
          });
        })
    } catch (e) {
      toast.hideAll();
      toast.error(`Invalid Qr Code`);
    }
  }
  return (
    <>
      <div className={''}></div>
      {!calendarView && <div className="user-wrapper">
        {
          props.type !== 'public-events' &&
          <>
            <div className="header-blk">
              <h2>Overview</h2>
            </div>
            <div className="cards-wrapper">
              <div className="cards-blk">
                <RateCard text='Total Events' value={overview.total || 0} />
                <RateCard text='Active Events' value={overview.upcoming || 0} />
                <RateCard text='Completed Events' value={overview.completed || 0} />
                <RateCard text='Canceled Events' value={overview.cancel || 0} />
              </div>
            </div>
          </>
        }

        <div className="search-blk search-blk-lead with-add-btn">
          <h2>Search</h2>
          <div className="lead-form-add-btn">
            <form onSubmit={handleSearch}>
              <div className="input-field">
                <label htmlFor="first_name">Title</label>
                <input type="text" id="title" name="title" onChange={handleChange} />
              </div>
              <div className="input-field">
                <label>Start Date</label>
                <div className="date-blk">
                  {/* <div className="calendar-blk">
                    <img src={calendar} alt='calendar-icon' />
                  </div> */}
                  <DatePicker
                    placeholderText={'MM/DD/YYYY'}
                    // minDate="01/01/2015"
                    selected={startDate}
                    isClearable={startDate ? true : false}
                    clearButtonClassName="clear-button"
                    onChange={(e) => setStartDate(e)}
                  />
                </div>
              </div>
              <div className="input-field">
                <label>End Date</label>
                <div className="date-blk">
                  {/* <div className="calendar-blk">
                    <img src={calendar} alt='calendar-icon' />
                  </div> */}
                  <DatePicker
                    placeholderText={'MM/DD/YYYY'}
                    // minDate="01/01/2015"
                    selected={endDate}
                    isClearable={endDate ? true : false}
                    clearButtonClassName="clear-button"
                    onChange={(e) => setEndDate(e)}
                  />
                </div>
              </div>
              <div className="input-field">
                <label htmlFor="contact">Client Name</label>
                <input id="clientName" name="client_name" onChange={handleChange} />
              </div>
              <button type='submit'>Search</button>
            </form>
            {
              props.type !== 'public-events' &&
              <div className="right">
                <button onClick={() => history.push('events/add')} ><img src={add} alt="" />Add Event</button>
              </div>
            }
          </div>
        </div>
      </div>}

      {!calendarView && <div className="table-wrapper">
        <div className="heading-blk">
          <div className="left">
            <h2>Results</h2>
            <p>Select an event to view details.</p>
          </div>
        </div>
        <div className="dataTable ns-table-fix">
          <DataTableComponent key="table-admin-users"
            // loading={loader}
            type={props.type === 'public-events' ? 'public-events' : 'events'}
            data={events}
            columns={columns}
            onFilterChange={handleChange}
            totalPage={totalPage}
          // limit={userDetail.limit}
          // refresh={() => getUsers()} 
          />
        </div>
      </div>}


      {
        calendarView &&
        <div className="full-calendar">
          <Calendar></Calendar>
        </div>
      }

      {
        <Popup className="rq-scanner-popup ns-popup" open={scan.open} onClose={() => setScan({ open: false })} closeOnDocumentClick={false}>
          {
            scan.open &&
            <Scanner callback={verfiyTicket} eventId={scan.event_id} close={() => setScan({ open: false })} />
          }
        </Popup>
      }
      {

        <Popup className="qr-popup" open={successPopup.open} onClose={() => setSuccessPopup({ open: false })} >
          <div className="success-section">
            <div className="qr-popup-heading">
              <h2>Ticket Scanned Successfully</h2>
              <span className="close" onClick={() => setSuccessPopup({ open: false })}>&times;</span>
            </div>
            <div class="cs-section-form">
              <span><strong>Event</strong> : {successPopup?.event?.title}</span>
              <span><strong>Ticket Count</strong> : {successPopup?.event_count}</span>
              {/* <span><strong>Payment Status</strong> : {successPopup?.ticketInfo?.payment_status}</span>
              <span><strong>Price</strong> : {successPopup?.ticketInfo?.total_price}</span> */}
            </div>
            <div className="cs-scanned-table">
              <table>
                <tbody>
                  {
                    Array.isArray(successPopup.event_tickets) && successPopup.event_tickets.length > 0 && successPopup.event_tickets.map((val, k) => (
                      <tr key={k}>
                        <td>#{val.ticket_no}</td>
                        <td className="scanned-data-name">{val.first_name} {val.last_name}</td>
                        <td className="scanned-data-email">{val.email} </td>
                        <td>{val.phone}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className="footer-btn">
            <button className="refund-btn" onClick={() => setSuccessPopup({
              open: false,
              event: {},
              event_count: 0,
              event_tickets: [],
              ticketInfo: {},
            })}>Ok</button>
          </div>
        </Popup>
      }

    </>
  );
}

export default withRouter(Event);
